import { BenefitActivityLogItemType } from "./Types";

const toTime = (value?: string | null): number => {
  if (!value) return 0;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
};

/** Latest entry first: by created_at, falling back to ID (auto-increment) when missing or equal. */
export const sortLogsLatestFirst = <T extends Pick<BenefitActivityLogItemType, "ID" | "created_at">>(
  logs: T[]
): T[] =>
  [...logs].sort(
    (a, b) => toTime(b.created_at) - toTime(a.created_at) || Number(b.ID) - Number(a.ID)
  );
